// eslint-disable-next-line import/prefer-default-export
export enum ApiGroup {
  ALZA = 'ALZA',
  KAUFLAND = 'KAUFLAND',
  ALLEGRO = 'ALLEGRO',
  MALL_GROUP = 'MALL_GROUP',
}
